import { GOOGLE_ADS_CAMPAIGN_STATUS } from '../../../../../../../services/exports/Constants';

export default {
  buttons: {
    back: 'Indietro',
  },
  metrics: {
    impressions: {
      label: 'Impressioni',
      description:
        'Il numero di volte in cui il tuo annuncio è stato mostrato nei risultati di ricerca Google o sui siti partner.',
    },
    clicks: {
      label: 'Clic',
      description: 'Il numero di volte in cui le persone hanno cliccato sul tuo annuncio.',
    },
    budget_spent: {
      label: 'Budget speso',
      description: "L'importo totale speso per questa campagna.",
    },
    absolute_top_impression_percentage: {
      label: '% Impressioni assolute in cima',
      description: 'La percentuale di volte in cui il tuo annuncio è apparso in cima ai risultati di ricerca Google.',
    },
    phone_calls: {
      label: 'Chiamate',
      description: 'Il numero totale di telefonate ricevute dal tuo annuncio.',
    },
    phone_impressions: {
      label: 'Impressioni telefoniche',
      description: "Il numero di volte in cui il tuo numero di telefono è stato visualizzato nell'annuncio.",
    },
    phone_through_rate: {
      label: 'Tasso di chiamate telefoniche',
      description:
        'La percentuale di impressioni telefoniche che hanno generato chiamate (Chiamate ÷ Impressioni telefoniche).',
    },
    directions: {
      label: 'Indicazioni stradali',
      description: 'Il numero di volte in cui gli utenti hanno richiesto indicazioni per la tua sede.',
    },
    daily_budget: {
      label: 'Budget giornaliero',
      description: "L'importo massimo impostato da spendere al giorno per questa campagna.",
    },
    status: {
      label: 'Stato',
      description: 'Lo stato di esecuzione attuale della tua campagna.',
    },
    ctr: {
      label: 'Percentuale di clic',
      description: "La percentuale di visualizzazioni dell'annuncio che hanno generato clic (Clic ÷ Impressioni).",
    },
    average_cpc: {
      label: 'Costo medio per clic',
      description:
        "L'importo medio pagato ogni volta che qualcuno fa clic sul tuo annuncio (Costo totale ÷ Clic totali).",
    },
    conversions_from_interactions_rate: {
      label: 'Tasso di conversione',
      description: "La percentuale di interazioni con l'annuncio che hanno portato a una conversione.",
    },
    start_date: {
      label: 'Data di inizio',
      description: 'La data di inizio della campagna.',
    },
    sales_from_google_ads: {
      label: 'Vendite da Google Ads',
      description: "L'importo totale generato tramite Google Ads.",
    },
  },
  status: {
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNSPECIFIED]: 'Non specificato',
    [GOOGLE_ADS_CAMPAIGN_STATUS.ENABLED]: 'Abilitato',
    [GOOGLE_ADS_CAMPAIGN_STATUS.PAUSED]: 'In pausa',
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNKNOWN]: 'Sconosciuto',
    [GOOGLE_ADS_CAMPAIGN_STATUS.REMOVED]: 'Rimosso',
  },
  error_messages: {
    loading_failed: 'Caricamento dei dettagli della campagna non riuscito. Riprova.',
  },
};
